<path
    d="M12 5.64507C10.9383 4.62619 9.49681 4 7.90909 4C4.64559 4 2 6.64559 2 9.90909C2 15.6984 8.33668 18.8955 10.9216 19.9588C11.6178 20.2452 12.3822 20.2452 13.0784 19.9588C15.6633 18.8955 22 15.6984 22 9.90909C22 6.64559 19.3544 4 16.0909 4C14.5032 4 13.0617 4.62619 12 5.64507Z"
    fill="currentColor"
/>
